namespace Matrix.Dashboards {
    export interface DashboardRow {
        DashboardCode?: string;
        Name?: string;
        CategoryCode?: string;
        Data?: DashboardData;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        Description?: string;
        ParamBindingsOnToolbar?: string[];
        NavigationOrder?: number;
        NavigationPath?: string;
        NavigationPermission?: string;
        DefaultForRoles?: string[];
        DefaultForUsers?: string[];
    }

    export namespace DashboardRow {
        export const idProperty = 'DashboardCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Dashboards.Dashboard';
        export const deletePermission = 'Administration:Dashboards';
        export const insertPermission = 'Administration:Dashboards';
        export const readPermission = 'Read:Dashboards';
        export const updatePermission = 'Administration:Dashboards';

        export declare const enum Fields {
            DashboardCode = "DashboardCode",
            Name = "Name",
            CategoryCode = "CategoryCode",
            Data = "Data",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            Description = "Description",
            ParamBindingsOnToolbar = "ParamBindingsOnToolbar",
            NavigationOrder = "NavigationOrder",
            NavigationPath = "NavigationPath",
            NavigationPermission = "NavigationPermission",
            DefaultForRoles = "DefaultForRoles",
            DefaultForUsers = "DefaultForUsers"
        }
    }
}
